
import { FqGrowthValue, LevelAchievedValue } from '@utils/sections/FrontlineGrowthIncentive.util'
import { makeAutoObservable } from 'mobx'
import { makePersistable } from 'mobx-persist-store'

interface FrontlineGrowthIncentiveData {
  frontlineGrowthIncentiveActive: boolean
  frontlineGrowthIncentiveLevelAchieved: LevelAchievedValue
  frontlineGrowthIncentiveFqGrowth: FqGrowthValue
}

export class FrontlineGrowthIncentiveStore implements FrontlineGrowthIncentiveData {
  frontlineGrowthIncentiveActive!: boolean
  frontlineGrowthIncentiveLevelAchieved!: LevelAchievedValue
  frontlineGrowthIncentiveFqGrowth!: FqGrowthValue

  constructor() {
    this.reset()
    makeAutoObservable(this, {}, { autoBind: true })
    makePersistable(this, {
      name: `${AIS_STORE}-FrontlineGrowthIncentive`,
      properties: ['frontlineGrowthIncentiveActive', 'frontlineGrowthIncentiveLevelAchieved', 'frontlineGrowthIncentiveFqGrowth']
    })
  }

  reset() {
    this.frontlineGrowthIncentiveActive = true
    this.frontlineGrowthIncentiveLevelAchieved = LevelAchievedValue.BELOW_F_PLATINUM
    this.frontlineGrowthIncentiveFqGrowth = FqGrowthValue.MAINTAIN
  }

  setFrontlineGrowthIncentiveActive(value: boolean) { this.frontlineGrowthIncentiveActive = value }
  setFrontlineGrowthIncentiveLevelAchieved(value: LevelAchievedValue) { this.frontlineGrowthIncentiveLevelAchieved = value }
  setFrontlineGrowthIncentiveFqGrowth(value: FqGrowthValue) { this.frontlineGrowthIncentiveFqGrowth = value }
}
